export default function Warning({}) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.725 16.6667H16.275C17.5583 16.6667 18.3583 15.275 17.7167 14.1667L11.4417 3.32499C10.8 2.21666 9.2 2.21666 8.55833 3.32499L2.28333 14.1667C1.64167 15.275 2.44167 16.6667 3.725 16.6667ZM10 10.8333C9.54167 10.8333 9.16667 10.4583 9.16667 9.99999V8.33333C9.16667 7.87499 9.54167 7.49999 10 7.49999C10.4583 7.49999 10.8333 7.87499 10.8333 8.33333V9.99999C10.8333 10.4583 10.4583 10.8333 10 10.8333ZM10.8333 14.1667H9.16667V12.5H10.8333V14.1667Z'
        fill='#F59B15'
      />
    </svg>
  );
}
